import { render, staticRenderFns } from "./PayForm_TransactionJunction.vue?vue&type=template&id=60b03b96&scoped=true&"
import script from "./PayForm_TransactionJunction.vue?vue&type=script&lang=js&"
export * from "./PayForm_TransactionJunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b03b96",
  null
  
)

export default component.exports